export interface QtyReportingTab {
  label: string;
  value: QtyReportingTabType;
}
export enum QtyReportingTabType {
  GENERAL = 'GENERAL',
  PLANNING_TARGET_CALC = 'PLANNING_TARGET_CALC',
  WELD_PROGRAM_MGMT = 'WELD_PROGRAM_MGMT',
  INSPECTION_TEST_RECORD = 'INSPECTION_TEST_RECORD',
}
